export class InputDialogSettings {
  constructor(
    public title: string,
    public content: string,
    public input: string,
    public inputPlaceholder: string,
    public showCancel: boolean,
    public showDelete?: boolean,
    public showInput = true
  ) {}
}
